import type * as Types from "../../schema.generated";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type UnavailableQuestionnaireTypesQueryVariables = Types.Exact<{
  email: Types.Scalars["String"];
  year: Types.Scalars["Int"];
}>;

export type UnavailableQuestionnaireTypesQuery = {
  __typename?: "Query";
  unavailableQuestionnaireTypes: Array<Types.QuestionnaireType>;
};

export const UnavailableQuestionnaireTypesDocument = gql`
  query unavailableQuestionnaireTypes($email: String!, $year: Int!) {
    unavailableQuestionnaireTypes(email: $email, year: $year)
  }
`;

/**
 * __useUnavailableQuestionnaireTypesQuery__
 *
 * To run a query within a React component, call `useUnavailableQuestionnaireTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useUnavailableQuestionnaireTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUnavailableQuestionnaireTypesQuery({
 *   variables: {
 *      email: // value for 'email'
 *      year: // value for 'year'
 *   },
 * });
 */
export function useUnavailableQuestionnaireTypesQuery(
  baseOptions: Apollo.QueryHookOptions<
    UnavailableQuestionnaireTypesQuery,
    UnavailableQuestionnaireTypesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    UnavailableQuestionnaireTypesQuery,
    UnavailableQuestionnaireTypesQueryVariables
  >(UnavailableQuestionnaireTypesDocument, options);
}
export function useUnavailableQuestionnaireTypesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    UnavailableQuestionnaireTypesQuery,
    UnavailableQuestionnaireTypesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    UnavailableQuestionnaireTypesQuery,
    UnavailableQuestionnaireTypesQueryVariables
  >(UnavailableQuestionnaireTypesDocument, options);
}
export type UnavailableQuestionnaireTypesQueryHookResult = ReturnType<
  typeof useUnavailableQuestionnaireTypesQuery
>;
export type UnavailableQuestionnaireTypesLazyQueryHookResult = ReturnType<
  typeof useUnavailableQuestionnaireTypesLazyQuery
>;
export type UnavailableQuestionnaireTypesQueryResult = Apollo.QueryResult<
  UnavailableQuestionnaireTypesQuery,
  UnavailableQuestionnaireTypesQueryVariables
>;
